<template>
  <v-app>
    <v-toolbar app color="primary" class="toolbar">
      <v-container fluid pa-0 class="my__toolbar">
        <v-row class="align-center justify-center row">
          <v-col class="col-4 col-md-5 disappear-mobile">
            <v-btn href="/" color="white" class="navbar-buttons primary--text">
              <v-icon>keyboard_arrow_left</v-icon>Voltar
            </v-btn>
            <!-- <v-btn to="/sobre" color="white" class="navbar-buttons primary--text">
              <img
                :src="require('../../assets/icon_ondivan.png')"
                class="mr-2"
                style="width: 20px;"
              />
              Sobre Nós
            </v-btn> -->
          </v-col>
          <v-col class="col-8 col-md-2">
            <v-row class="align-md-center justify-md-center row">
              <img :src="require('../../assets/ondivan_marca_white.svg')" width="70%;" />
            </v-row>
          </v-col>
          <v-col class="col-5 col-md-5 d-none d-md-block disappear-mobile"></v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <section>
      <v-container>
        <v-row class="wrap justify-center">
          <v-col class="col-12 col-md-10">
            <h1 class="primary--text mt-3">Política de Privacidade</h1>
            <hr class="primary--lightGray mt-3" />
            <p class="primary--lightGray mb-0 mt-3">Atualizada em 03 de Janeiro de 2020.</p>
            <p class="primary--lightGray mb-0 mt-3">
              1. Geral<br />
              Esta Política de Privacidade foi concebida para comunicar as nossas práticas relativas
              ao tratamento (inclui recolha, armazenamento, utilização, compartilhamento etc) de
              dados pessoais dos PACIENTES e dos PSICÓLOGOS no ONDIVAN (doravante assim denominada
              ou somente “Plataforma”), que engloba o website e seus subdomínios, aplicativos,
              programas e demais extensões. A Plataforma é de propriedade da Inês Cristina Miranda
              Mata Cunha da Silva cujo NIF é 292207778, e está sob sua responsabilidade e gestão.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              2. O que são Dados Pessoais<br />
              Os dados pessoais são aqueles informados pelos PACIENTES, os quais podem ser usados
              para identificá-los individualmente.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              3. Autorização de Recolher Informações<br />
              Ao utilizar a plataforma, -- deverá aceitar e autorizar, através do botão “li e
              concordo com os termos”, a recolha, armazenamento, utilização e demais formas de
              tratamento, dos seus dados pessoais, nos termos da presente política de privacidade.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              3.1. Poderá desistir de consentir com as disposições desta Política de Privacidade, a
              qualquer momento, bastando para tal que notifique o ONDIVAN através do e-mail
              <a href="mailto: geral@ondivan.net">geral@ondivan.net</a>, no prazo de 05 (cinco) dias
              úteis.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              4. Regulamentação.<br />
              A Plataforma atua de acordo com a legislação brasileira, atendendo, inclusive e
              especialmente, com os termos da Lei nº. 12.965/2014 (o Marco Civil da Internet) e da
              Lei nº 13.709/2018 (Lei Geral de Protecção de Dados) e com o no Regulamento Geral
              sobre a Proteção de Dados (RGPD) da União Europeia.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              5. Data Protection Officer.<br />
              O ONDIVAN nomeou Pedro Cunha da Silva como Data Protection Officer ou Encarregado da
              Protecção de Dados para responder por todas as questões relativas a protecção de dados
              como, por exemplo, manter contato com autoridades nacionais, PACIENTES e PSICÓLOGOS,
              para fornecer quaisquer informações ou notificações. O contato poderá ocorrer através
              do e-mail
              <a href="mailto: geral@ondivan.net">geral@ondivan.net</a>, endereço rua José Augusto
              Torres, lote 123, 5º Esq. Torres Novas 2350-086 ou telefone +351 963909958 de acordo
              com o previsto no artigo 13 do GDPR.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              6. Contacto.<br />
              Em caso de dúvida ou sugestões sobre a Política de Privacidade da Plataforma ou
              qualquer outra informação, o PACIENTE poderá entrar em contacto com os administradores
              através do email
              <a href="mailto: geral@ondivan.net">geral@ondivan.net</a>.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              7. Controlo de Informações.<br />
              Esta Política descreve quais os dados pessoais que podem ser recolhidos do PACIENTE ou
              PSICÓLOGO enquanto utiliza os serviços da Plataforma, como essas informações podem ser
              utilizadas e as precauções tomadas contra o acesso ou uso destas informações de forma
              não autorizada.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              8. Recolha.<br />
              O ONDIVAN poderá recolher, armazenar e utilizar as seguintes informações e/ou dados
              pessoais dos PACIENTES e PSICÓLOGOS:
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              PACIENTES: foto de perfil, nome completo, data de nascimento, país, estado, cidade,
              CPF ou NIF, número de telefone, e-mail e formas de contato (Whatsapp Hangouts,
              Facebook Messenger ou Skype).
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              PSICÓLOGOS: foto de perfil, e-mail, nome completo, data de nascimento, país, estado,
              cidade, OPP (Número da ordem), Número de CRP, grau acadêmico, foto da OPP (frente e
              verso) e áreas de atuação (campo de seleção).
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              9. Registros.<br />
              O ONDIVAN também poderá recolher, armazenar e utilizar as seguintes informações:
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Registo em banco de dados de quaisquer arquivos ou informação carregados no ONDIVAN
              pelos titulares;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Os detalhes de acesso ao ONDIVAN e dos recursos que o titular acessou;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Informações do dispositivo de acesso utilizado, incluindo, por exemplo, modelo do
              hardware, sistema operacional e versão, nomes e versões dos arquivos, idioma de
              preferência, identificador exclusivo do dispositivo, identificadores de publicidade,
              número de série, informações referentes ao movimento do dispositivo e informações de
              rede;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Informações de registo do servidor que podem incluir informações como endereço IP do
              dispositivo.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Mapeamento de cliques no navegador, dados de navegação, estatísticos, demográficos,
              entre outros;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              10. Exceções para Compartilhamento de Dados Pessoais de PACIENTES.<br />
              O ONDIVAN não divulga a terceiros qualquer dado pessoal fornecido pelos PACIENTES ou
              PSICÓLOGOS através da plataforma ONDIVAN, exceto:
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Casos em que o ONDIVAN for obrigado a divulgar ou partilhar os dados recolhidos, a fim
              de cumprir ordem judicial, ou para efeitos de prevenção de fraude ou outros crimes,
              bem como em resposta à solicitação de informações apresentada por autoridade
              competente, se entendermos que a divulgação está de acordo ou é exigida conforme as
              leis, regulamentos ou procedimentos processuais aplicáveis;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Para proteger os direitos, bens ou a segurança do ONDIVAN e da Plataforma;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Com agentes da lei e/ou autoridades governamentais, se entender-se que suas ações são
              inconsistentes em relação às disposições em nossos termos de uso, ou para proteger os
              direitos, a propriedade ou a segurança do ONDIVAN, de seus PACIENTES, ou de outros;
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              11. Autorizações de Contato e Divulgação.<br />
              Os PACIENTES e PSICÓLOGOS autorizam o ONDIVAN a contatá-los utilizando qualquer um dos
              meios de contato informados no cadastro no ONDIVAN.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              12. O que são os Cookies.<br />
              Um cookie é um espaço de informação armazenado localmente no computador ou dispositivo
              do PACIENTE, e que contém informação acerca das atividades deste na Internet. Cookies
              Funcionais: Estes cookies são usados pelo ONDIVAN por algumas das suas
              funcionalidades, procurando oferecer uma melhor experiência ao navegar pela
              plataforma.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              13. Cookies Utilizados.<br />
              Os cookies podem ser usados de diferentes formas e modalidades. O ONDIVAN
              poderáutilizar:
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Cookies de Desempenho: Este tipo de cookie recolhe informações anônimas sobre a forma
              como o PACIENTE ou PSICÓLOGO utiliza a plataforma, para podermos otimizá-la. As
              informações recolhidas por estes cookies nunca contêm detalhes pessoais a partir dos
              quais seja possível identificá-lo.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Cookies Funcionais: Estes cookies são usados pelo ONDIVAN por algumas de suas
              funcionalidades, buscando lhe oferecer uma melhor experiência ao navegar pela
              plataforma.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              Cookies publicitários: estes cookies recolhem informações sobre os hábitos de
              navegação, buscando tornar a publicidade mais relevante para o usuário.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              14. Acesso aos Cookies.<br />
              O acesso aos cookies termina assim que o PACIENTE ou PSICÓLOGO fecha o navegador. É
              dada ao PACIENTE a possibilidade de aceitar ou recusar os cookies.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              15. Consentimento para Utilização de Cookies.<br />
              É necessária a aceitação do PACIENTE, antes de iniciada a seção, para que os Cookies
              sejam utilizados.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              16. Opção sem Cookies.<br />
              O titular pode optar por recusar o uso de cookies. Se o PACIENTE optar por não os
              aceitar, o seu acesso à maior parte das informações disponíveis na Plataforma não será
              comprometido. Contudo, o titular poderá não conseguir usar plenamente os serviços
              oferecidos.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              17. Acesso e Retificação de Dados Pessoais.<br />
              Os PACIENTES e PSICÓLOGOS têm direito a aceder aos seus dados pessoais sob posse do
              ONDIVAN, contatando os administradores através do e-mail
              <a href="mailto: geral@ondivan.net">geral@ondivan.net</a> ou do telefone (+351
              926638181), que será respondido em horário comercial, de segunda-feira a sexta-feira,
              das 9h30 min às 18h do fuso horário do país solicitado.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              18. Exclusão.<br />
              O PACIENTE tem direito de solicitar a exclusão dos seus dados pessoais armazenados no
              ONDIVAN, a qualquer momento, sem demora injustificada.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              19. Incorreção de Informações.<br />
              É responsabilidade do titular manter suas informações atualizadas, sendo certo que, no
              caso de incorreção, o ONDIVAN poderá atualizá-las ou excluí-las, excetuando-se os
              casos de necessidade de manutenção para fins comerciais legítimos ou jurídicos.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              20. Medidas Necessárias de Protecção.<br />
              O ONDIVAN toma todas as medidas de segurança necessárias para proteger os dados
              pessoais dos PACIENTES e dos PSICÓLOGOS e para protegê-los contra a perda, utilização
              indevida, acesso, divulgação, alteração ou destruição não autorizados.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              21. Protecção de Senhas.<br />
              O PACIENTE e PSICÓLOGO são igualmente responsáveis por tomar medidas cabíveis
              destinadas a proteger as suas senhas, nomes de usuário e outros recursos de acesso
              especiais ao cadastro pessoal no ONDIVAN.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              22. Alterações na Política de Privacidade.<br />
              O ONDIVAN pode alterar a Política de Privacidade da Plataforma de tempos em tempos. O
              uso de informações recolhidas agora está sujeito à Política de Privacidade em vigor.
              Se o ONDIVAN realizar mudanças na forma como utiliza as informações pessoais,
              notificará seus PACIENTES e PSICÓLOGOS através do envio de e-mail.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              23. Ajustes Não Notificados.<br />
              Pequenos ajustes nesta Política de Privacidade podem ocorrer sem afetar
              sigicativamente as formas em que o ONDIVAN trata as informações recolhidas, de forma
              que estes não precisarão ser informados.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              24. Envio de Comunicações.<br />
              Os PACIENTES e os PSICÓLOGOS, ao se inscreveram, concordam que o ONDIVAN envie para o
              seu e-mail notificações, publicidades, novidades sobre os serviços e informações
              importantes sobre a utilização da Plataforma que necessitem da sua atenção.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              24.1. Opção por Não Recebimento.<br />
              Ao receber um e-mail em nome da Plataforma, haverá a possibilidade de optar por não
              receber mais, utilizando da opção opt-out ou através de solicitação por e-mail.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              25. Política AntiSpam.<br />
              A Plataforma toma os cuidados necessários para evitar o envio não solicitado de
              e-mails.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              26. Confidencialidade.<br />
              É assegurado o máximo de confidencialidade no tratamento da lista de telefones e
              e-mails durante as tarefas regulares de administração do ONDIVAN.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              27.Armazenamento.<br />
              Os dados pessoais das contas dos PACIENTES e PSICÓLOGOS são armazenados em um serviço
              de banco de dados na "nuvem" (JawsDB MySQL), em servidores nos Estados Unidos da
              América, apenas os colaboradores autorizados pelo ONDIVAN podem ter acesso às suas
              informações pessoais, estando obrigatoriamente sujeitos aos deveres de
              confidencialidade e rigoroso respeito à sua privacidade nos termos desta Política.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              28. Segurança da Informação.<br />
              Todas as transações do ONDIVAN são criptografadas e o os dados pessoais de PACIENTES e
              PSICÓLOGOS.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              29. Transferência Internacional.<br />
              Os dados pessoais armazenados pelo ONDIVAN estarão sujeitos às normas relativas à
              transferência internacional de dados pessoais, de acordo com o disposto no artigo 33
              da LGPD brasileira e no artigo 44 do GDPR.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              30.Notificação.<br />
              Se o ONDIVAN tomar conhecimento de qualquer violação à segurança própria ou a empresas
              de hospedagem, incluindo qualquer hacker ou outro ‘’data breach’’, iremos notificar as
              autoridades nacionais, os PACIENTES ou PSICÓLOGOS eventualmente afetados, acerca dessa
              violação e iremos fornecer o máximo de detalhes referente à natureza, extensão da
              violação e os dados comprometidos, no prazo de 72 (setenta e duas) horas após tomar
              conhecimento da violação, de acordo com o artigo 33 do GDPR
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              32. Cooperação.<br />
              Os PACIENTES ou os PSICÓLOGOS serão responsáveis por indenizar o ONDIVAN por todos os
              custos e danos que este possa incorrer, como resultado da violação desta Política de
              Privacidade por si provocados.
            </p>
            <p class="primary--lightGray mb-0 mt-3">
              33.Limitação de Responsabilidade.<br />
              Esta Política de Privacidade aborda apenas o uso e divulgação de informações
              recolhidas pela Plataforma do ONDIVAN. Se os PACIENTES ou PSICÓLOGOS divulgarem suas
              informações a websites de terceiros, regras diferentes podem ser aplicadas à sua
              utilização das informações.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-footer height="auto" color="primary">
      <v-row class="align-center justify-center ma-0">
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 12px">
          <img :src="require('../../assets/ondivan_marca_white.svg')" width="180px;" />
        </v-col>
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 14px">
          <strong>RESPONSÁVEL TÉCNICO:</strong>
          <br />Inês Mata {{ $t('footer.opp') }}
        </v-col>
        <v-col
          class="py-3 d-flex text-center align-center justify-center col-12 col-md-2"
          style="font-size: 14px"
        >
          <div v-if="lang === 'pt'">
            <a href="https://www.livroreclamacoes.pt/" target="_blank" class="white--text">
              Livro de Reclamações
            </a>
          </div>
          <!-- <div>
            <a href="/privacidade" class="white--text">Política de privacidade</a>
          </div> -->
        </v-col>
        <v-col class="py-3 text-center col-12 col-md-2" style="font-size: 14px">
          <a target="blank" href="https://fb.me/ondivan.net">
            <img :src="require('../../assets/facebook_icon.png')" width="40px;" />
          </a>
          <a target="blank" href="https://www.instagram.com/on.divan/">
            <img :src="require('../../assets/instagram_icon.png')" width="40px;" class="ml-4" />
          </a>
        </v-col>
        <v-col
          class="pa-3 row text-center col-12 col-md-2 align-center d-flex"
          style="font-size: 12px"
        >
          <div class="d-flex row align-center justify-center">
            <div>
              <p class="mb-1 mr-1 white--text" style="font-size: 1.2rem">
                <strong>Email:</strong>geral@ondivan.net
              </p>
            </div>
            <div>
              <!-- <a target="blank" href="https://www.easypay.pt/">
              <img :src="require('../../assets/easypay.jpg')" style="width: 100px;" />
              </a> -->
            </div>
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import getLanguage from '../../utils/getLanguage';

export default {
  data() {
    return {
      lang: '',
    };
  },

  created() {
    this.lang = getLanguage(window.location.href);
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
